<template>
  <div class="order-actions">
    <button
      v-if="showActions && isAdmin"
      type="button"
      class="order-action-btn is-danger"
      title="حذف سفارش"
      @click="removeOrder"
    >
      <b-icon icon="trash"/>
    </button>

    <template v-if="showActions && item.order_type == 2">
      <router-link
        class="order-action-btn"
        target="_blank"
        title="اقساط"
        :to="{ name: 'LoanItems', params: { user: item.user && item.user.id, order: item.id }}"
      >
        <b-icon icon="person-lines-fill"/>
      </router-link>

      <router-link
        v-if="isAdmin || isUserStore"
        class="order-action-btn"
        target="_blank"
        title="ویرایش"
        :to="{ name: 'updateOrder', params: { id: item.id } }"
      >
        <b-icon icon="pen-fill"/>
      </router-link>
    </template>

    <template v-else-if="showActions">
      <template v-if="isPaid">
        <router-link
          class="order-action-btn"
          target="_blank"
          title="فاکتور"
          :to="{ name: 'Factor', params: { orderId: item.id } }"
        >
          <b-icon icon="basket-fill"/>
        </router-link>

        <button
          v-if="item.status && item.status.status_id >= 2"
          type="button"
          class="order-action-btn"
          :class="{ 'is-success': hasShipmentCode }"
          title="کد مرسوله"
          v-b-modal="`general-info-${item.id}`"
        >
          <b-icon icon="pen"/>
        </button>

        <b-modal :id="`general-info-${item.id}`" hide-footer>
          <div class="text-right">
            <form @submit.prevent="updateOrderGeneralInfo">
              <b-form-group
                id="input-group-1"
                label="کد مرسوله"
                label-for="input-1"
                class="mb-4 mt-3"
              >
                <b-form-input
                  v-model="item.shipment_code"
                  type="text"
                  placeholder="کد مرسوله"
                  class="text-left"
                />
              </b-form-group>
              <b-button class="btn w-100 my-2 btn-success" pill type="submit">ثبت</b-button>
            </form>
          </div>
        </b-modal>
      </template>

      <router-link
        v-else-if="findAttributeOnSiteInfo('show_pre_factor')[0] == 1"
        class="order-action-btn"
        target="_blank"
        title="پیش‌فاکتور"
        :to="{ name: 'Factor', params: { orderId: item.id } }"
      >
        <b-icon icon="basket-fill"/>
      </router-link>

      <router-link
        v-if="isAdmin || isUserStore"
        class="order-action-btn"
        target="_blank"
        title="ویرایش"
        :to="{ name: 'updateOrder', params: { id: item.id } }"
      >
        <b-icon icon="pen-fill"/>
      </router-link>

      <router-link
        class="order-action-btn"
        target="_blank"
        title="فاکتور عمومی"
        :to="{ name: 'FactorWithSlug', params: { slug: item.slug } }"
      >
        <b-icon icon="card-text"/>
      </router-link>
    </template>

    <m-comment-create-modal-1
      v-if="showComment"
      :custom_button="true"
      :commentable_id="item.id"
      commentable_type="order"
    >
      <template #modal-button>
        <b-button
          variant="transparent"
          class="border-0 p-0"
          v-b-modal="'create-comment-' + item.id"
        >
          <span class="order-action-btn">
            <b-icon class="box bounce-7" icon="chat-square-text-fill"/>
          </span>
        </b-button>
      </template>
    </m-comment-create-modal-1>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";

export default {
  name: "OrderItemActions",
  props: {
    item: {
      type: Object,
      required: true
    },
    showActions: {
      type: Boolean,
      default: true
    },
    showComment: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      isAdmin: 'User/isAdmin',
      isUserStore: 'User/isUserStore',
    }),
    isPaid() {
      return this.item.payment_status && this.item.payment_status.status_id == 2;
    },
    hasShipmentCode() {
      return this.item.shipment_code !== null && this.item.shipment_code !== '';
    }
  },
  methods: {
    findAttributeOnSiteInfo,
    updateOrderGeneralInfo() {
      this.$store.dispatch('ShoppingCart/updateOrderGeneralInfo', {
        order_id: this.item.id,
        shipment_code: this.item.shipment_code,
      });
    },
    removeOrder() {
      if (confirm('ایا از حذف اطمینان دارید؟')) {
        this.$store.dispatch('Transaction/removeOrder', this.item).then(() => {
          this.$store.dispatch("ShoppingCart/getAllOrders");
        });
      }
    }
  }
}
</script>

<style scoped>
.box {
  animation-duration: 2s;
  animation-iteration-count: infinite;
  color: #d97706;
  transform-origin: bottom;
}

.bounce-7 {
  animation-name: bounce-7;
  animation-timing-function: cubic-bezier(0.280, 0.840, 0.420, 1);
}

@keyframes bounce-7 {
  0% { transform: scale(1, 1) translateY(0); }
  10% { transform: scale(1.1, .9) translateY(0); }
  30% { transform: scale(.9, 1.1) translateY(-8px); }
  50% { transform: scale(1.05, .95) translateY(0); }
  57% { transform: scale(1, 1) translateY(-4px); }
  64% { transform: scale(1, 1) translateY(0); }
  100% { transform: scale(1, 1) translateY(0); }
}
</style>
